import { Component, h, Prop, State, Watch, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'qumra-selector',
  styleUrl: 'qumra-selector.css',
  shadow: true,
})
export class QumraSelector {
  @Prop() multi: boolean = false; 
  @Prop() options: any[] = []; 
  @Prop() default: any[] = [];
  @State() isOpen: boolean = false;
  @State() selectedOptions: string[] = [];

  @Event() selected: EventEmitter<any>;

  @Watch('default')
  watchDefault(newValue: any[]) {
    this.selectedOptions = [...newValue];
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(value: string) {
    if (this.multi) {
      if (this.selectedOptions.includes(value)) {
        this.selectedOptions = this.selectedOptions.filter(item => item !== value);
      } else {
        this.selectedOptions = [...this.selectedOptions, value];
      }
    } else {
      this.selectedOptions = [value];
      this.toggleDropdown();
    }

    this.selected.emit(this.selectedOptions); 
  }

  render() {
    return (
      <div class="relative">
        <div 
          class="selector-header rounded-lg cursor-pointer border px-3 h-[40px] border-[#E5E5E5] flex items-center justify-between"
          onClick={() => this.toggleDropdown()}
          role="button"
          aria-expanded={this.isOpen ? 'true' : 'false'}
        >
          <span class="selector-label">
            {this.selectedOptions.length > 0 ? this.selectedOptions.join(', ') : 'Select options'}
          </span>
        </div>
        
        <div class={`dropdown-content transition-all duration-300 transform ${this.isOpen ? 'max-h-[200px] opacity-100 scale-100' : 'max-h-0 opacity-0 scale-95'} overflow-hidden absolute w-full border border-[#E5E5E5] rounded-lg bg-white shadow-md z-[100] mt-2`}>
          {this.options.map((item, index) => (
            <div 
              key={index} 
              class={`option-item flex justify-between gap-2 items-center p-2 hover:bg-gray-100 cursor-pointer ${this.selectedOptions.includes(item.value) ? 'bg-gray-200' : ''}`}
              onClick={() => this.selectOption(item.value)} 
            >
              {this.multi && this.selectedOptions.includes(item.value) && (
                <svg 
                  width="12" 
                  height="12" 
                  viewBox="0 0 12 12" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg" 
                  class="checkmark-icon"
                >
                  <path 
                    d="M10 3L4.5 8.5L2 6" 
                    stroke="black" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"
                  />
                </svg>
              )}
              <div class="indicator w-4 h-4 rounded-full bg-[--mainColor]"></div>
              <span class="option-label">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
